import React from "react";

export default function InstantWinPanel(props) {
  const { onInstantWin } = props;
  return (
    <React.Fragment>
      <h3>Having TOO MUCH fun?</h3>
      <section id="section-instant-win">
        <p>
          This game uses techniques developed by casinos and drug dealers to
          make you want to KEEP PLAYING.
          <br />
          Please, do not become addicted to this game.
          <br />
          If you feel overwhelmed, use this escape button:
        </p>
        <p>
          <button id="instant-win-btn" onClick={onInstantWin}>
            instant win
          </button>
        </p>
      </section>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/InstantWinPanel.jsx